import { SxProps } from '@mui/material';

export const overflowChipTagsContainerSx: SxProps = {
	display: 'flex',
	gap: 0.5,
	flexWrap: 'wrap',
	alignItems: 'center',
};

export const overflowChipTagsSummaryWrapperSx: SxProps = {
	display: 'flex',
	alignItems: 'center',
};